import { render, staticRenderFns } from "./UpdateReturnBill.vue?vue&type=template&id=2a587da0&scoped=true"
import script from "./UpdateReturnBill.vue?vue&type=script&lang=js"
export * from "./UpdateReturnBill.vue?vue&type=script&lang=js"
import style0 from "./UpdateReturnBill.vue?vue&type=style&index=0&id=2a587da0&prod&scoped=true&lang=css"
import style1 from "./UpdateReturnBill.vue?vue&type=style&index=1&id=2a587da0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a587da0",
  null
  
)

export default component.exports